import { render, staticRenderFns } from "./PostPreview.vue?vue&type=template&id=1f3b897e&scoped=true&"
import script from "./PostPreview.vue?vue&type=script&lang=js&"
export * from "./PostPreview.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PostPreview.vue?vue&type=style&index=0&id=1f3b897e&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1f3b897e",
  "2c00f1b3"
  
)

export default component.exports